var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "analise" },
    [
      _c("h3", { staticClass: "titulo-cadastar-certificado" }, [
        _vm._v("Cadastrar Certificado Digital")
      ]),
      _c(
        "el-card",
        { staticClass: "card-container", attrs: { shadow: "hover" } },
        [
          _c("app-anexo", {
            attrs: {
              id: "upload-atualizacao-base",
              files: _vm.anexos,
              fileType: ["pfx", "p12"]
            },
            on: {
              uploadFile: _vm.uploadFile,
              removeFile: _vm.removeFile,
              downloadDocumentoCadastro: _vm.downloadDocumentoCadastro
            }
          }),
          _c("div", { staticClass: "buttons" }),
          _c("app-buttons-cadastro", {
            attrs: { isPrimeiroPasso: true, isUltimoPasso: true },
            on: { cancelar: _vm.cancelar, finalizar: _vm.salvarCertificado }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7b0f02d5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b0f02d5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/assinatura/CadastroCertificado.vue
// module id = null
// module chunks = 